import { h, Fragment } from 'preact';
import { useState } from 'preact/hooks';
import clsx from 'clsx';
import CaretUp from './icon/caret-up.svg';
import CaretDown from './icon/caret-down.svg';
import RichText from './richtext';

// eslint-disable-next-line max-len
const Accordion = ({
  title,
  content,
  isGeneric = true,
  classes,
  children,
  isRte = true,
  isPdp = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const isString = typeof content === 'string';
  const stringMetafield = isString
    ? content?.includes('metafield-rich_text_field')
    : false;
  return (
    <>
      {(content || children) && (
        <>
          <div
            className={clsx(
              classes?.accordion,
              'cursor-pointer flex justify-between items-center',
              isOpen && 'pb-5',
            )}
            onClick={() => setIsOpen(!isOpen)}
          >
            <p className={classes?.title}>{title}</p>
            {isOpen ? <CaretUp /> : <CaretDown />}
          </div>
          <div className={clsx(classes?.content, isOpen && '!max-h-[1000px]')}>
            {children && <div className="mb-6">{children}</div>}
            {!children && isGeneric && content && (
              <RichText data={JSON.parse(content)} />
            )}
            {isPdp ? (
              <>
                {!children && content && !isGeneric && !stringMetafield && (
                  <div className={clsx('mb-6', isRte && 'rte font-13')}>
                    {content}
                  </div>
                )}
                {!children && content && !isGeneric && stringMetafield && (
                  <div
                    className={clsx('mb-6', isRte && 'rte font-13')}
                    dangerouslySetInnerHTML={{ __html: content }}
                  />
                )}
              </>
            ) : (
              <>
                {!children && content && !isGeneric && (
                  <div
                    className={clsx('mb-6', isRte && 'rte font-13')}
                    dangerouslySetInnerHTML={{ __html: content }}
                  />
                )}
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Accordion;
